import { useMutation } from "react-query";

import axios from "axios";

import {
  DescriptiveColumn,
  FeatureImportanceSummary,
  UseCalculateImportanceParams
} from "../types";

const DEFAULT_DESCRIPTIVE_COLUMNS: DescriptiveColumn[] = [
  {
    Property: "Uwi",
    NiceName: "Entity"
  }
];

const ML_SERVICE_ADDRESS = process.env.REACT_APP_ML_SERVICE;

export function useCalculateImportance() {
  return useMutation<FeatureImportanceSummary, unknown, UseCalculateImportanceParams>(
    async ({
      target,
      features,
      descriptiveColumns = DEFAULT_DESCRIPTIVE_COLUMNS,
      filterId,
      fields,
      normalize
    }: UseCalculateImportanceParams) => {
      if (!fields.includes(target.Property)) {
        fields = [...fields, target.Property];
      }
      const body = {
        InputData: {
          DescriptiveColumns: descriptiveColumns,
          Targets: [target],
          Features: features,
          Normalize: normalize ?? undefined
        },
        filterId,
        fields
      };
      const response = await axios.post<FeatureImportanceSummary>(
        `${ML_SERVICE_ADDRESS}/feature-importance`,
        body
      );
      return response.data;
    }
  );
}
